import CheckoutTranslate from '@/app/features/Checkout/translate';

export default {
  pt_BR: {
    Checkout: CheckoutTranslate.pt_BR,
    signin: 'Entrar',
    signup: 'Quero me cadastrar',
    or: 'ou',
    OR: 'OU',
    of: 'de',
    company: 'Empiricus',
    hello: 'Olá',
    back: 'Voltar',
    for: 'para',
    and: 'e',
    byMore: 'por mais',
    calendar: {
      day: 'dia',
      days: 'dias',
      month: 'mês',
      months: 'meses',
      week: 'semana',
      weeks: 'semanas',
      year: 'ano',
      years: 'anos',
      lifelong: 'vitalício'
    },
    interval: {
      day: 'diario',
      days: 'diario',
      month: 'mensal',
      months: 'mensal',
      week: 'semanal',
      weeks: 'semanal',
      year: 'anual',
      years: 'anual',
      lifelong: 'vitalício'
    },
    interval_plural: {
      day: 'diarios',
      days: 'diarios',
      month: 'mensais',
      months: 'mensais',
      week: 'semanais',
      weeks: 'semanais',
      year: 'anuais',
      years: 'anuais',
      lifelong: 'vitalício'
    },
    dates: {
      days: {
        full: ' dias',
        short: 'd',
        default: ':',
      },
      hours: {
        full: ' horas',
        short: 'h',
        default: ':',
      },
      minutes: {
        full: ' minutos',
        short: 'm',
        default: ':',
      },
      seconds: {
        full: ' segundos',
        short: 's',
        default: '',
      },
    },
    attention: 'Atenção!',
  },
};
